if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;
      const idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      if (document.body && document.body.hasAttribute('data-cb-template-cart')) {
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      } else {
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }
      this.submitButton = this.querySelector('[type="submit"]');
      if (this.submitButton && document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (document.body && document.body.hasAttribute('data-cb-template-cart')) {
        evt.stopImmediatePropagation();
      }
      if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const loadingSpinner = this.querySelector('.loading-overlay__spinner');
      if (loadingSpinner) loadingSpinner.classList.remove('hidden');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.section || section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        } else {
          this.cart.activeElement = document.activeElement;
        }
      }

      const formIdInput = this.form.querySelector('[name=id]');
      this.formIdInputValue = formIdInput ? formIdInput.value : '';
      if (this.formIdInputValue.includes(',')) {
          formData.delete('id');
          formData.delete('quantity');
      } 
      
      config.body = formData;

      this.skipCart = false;
      if (formIdInput && formIdInput.dataset.skipCart && formIdInput.dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            const submitButtonText = this.submitButton.querySelector('span');
            if (submitButtonText) submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.skipCart) {
            window.location = "/checkout";
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const renderCart = (state) => {
            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const renderState = (cartState) => {
              if (this.cart && typeof this.cart.renderContents === 'function') {
                this.cart.renderContents(cartState);
              } else {
                window.location = window.routes.cart_url;
              }
            };

            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { renderState(state) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              renderState(state);
            }
          };

          if (
            window.CushyBumCartOffer &&
            typeof window.CushyBumCartOffer.formHasCushyBum === 'function' &&
            window.CushyBumCartOffer.formHasCushyBum(this.form)
          ) {
            renderCart(response);
            if (typeof window.CushyBumCartOffer.syncAndRender === 'function') {
              window.setTimeout(() => {
                window.CushyBumCartOffer.syncAndRender({ fallbackState: response, openDrawer: true });
              }, 0);
            }
          } else {
            renderCart(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          const loadingSpinner = this.querySelector('.loading-overlay__spinner');
          if (loadingSpinner) loadingSpinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
